import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import SubscriptionServices from "./SubcriptionsServices";
export const getExistingSubcriptions = createAsyncThunk(
  "subscriptions/listSubscriptions",
  async (userId, thunkAPI) => {
    console.log(userId,"userIdewreewr")
    try {
      return await SubscriptionServices.fetch_all_active_services(userId);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

const initialState = {
  error: null,
  status: "idle",
  data: [],
  message: "",
};

export const listExistingSubcriptionsSlice = createSlice({
  name: "subscriptions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getExistingSubcriptions.fulfilled, (state, { payload }) => {
      state.data = payload;
      state.error = null;
      state.status = "succeeded";
    });
    builder.addCase(getExistingSubcriptions.pending, (state, payload) => {
      state.status = "loading";
      state.error = null;
      state.data = [];
    });
    builder.addCase(getExistingSubcriptions.rejected, (state, { payload }) => {
      state.status = "failed";
      state.data = [];
      state.error = payload;
    });
  },
});

// Action creators are generated for each case reducer function
export const {} = listExistingSubcriptionsSlice.actions;

export default listExistingSubcriptionsSlice.reducer;
